export default __webpack_public_path__ + "src/images/packages/qambathi-mountain-lodge/46ad66c2cea1f9e3eabf45e0d819b3be-3.jpg";